<main class="table-page table-page--fill" dir="rtl">
  <header class="header">
    <div class="title-row">
      <button class="back" type="button" aria-label="بازگشت" (click)="goBack()">
        <i class="fa fa-arrow-right"></i>
      </button>
      <div class="title-block"><h1 class="title">پشتیبانی</h1></div>
      <div class="actions">
        <button
          class="btn-round btn-round-primary"
          type="button"
          aria-label="افزودن"
          data-tip="افزودن"
          [disabled]="loading"
          (mouseenter)="pageTooltip.show($event, 'افزودن')"
          (mouseleave)="pageTooltip.hide()"
          (focus)="pageTooltip.show($event, 'افزودن')"
          (blur)="pageTooltip.hide()"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal"
        >
          <i class="fa fa-plus"></i>
        </button>
      </div>
    </div>
  </header>
  <section class="card">
    <div class="table-toolbar">
      <label class="search-wrap">
        <input
          class="control"
          type="search"
          [(ngModel)]="searchText"
          (ngModelChange)="onSearchChange()"
          placeholder="جستجو در جدول: شماره تیکت، تاریخ، زمان، وضعیت تیکت، موضوع تیکت..."
          [disabled]="loading"
        />
        <i class="fa fa-search"></i>
      </label>
      <div class="toolbar-actions">
        <button
          class="btn btn-soft"
          type="button"
          ngxPrint
          [useExistingCss]="true"
          [printTitle]="tableTitle"
          [printSectionId]="printId"
          [disabled]="loading || hasError || !filteredRows.length"
        >
          <i class="fa fa-print"></i> چاپ
        </button>
        <button
          class="btn btn-soft"
          type="button"
          (click)="exportExcel()"
          [disabled]="loading || hasError || !filteredRows.length"
        >
          <i class="fa fa-file-excel-o"></i> خروجی اکسل
        </button>
      </div>
    </div>
    <div class="body">
      <div
        class="loader"
        [class.show]="tableLoading"
        role="status"
        aria-live="polite"
      >
        <div class="spinner"></div>
        <span>در حال دریافت اطلاعات…</span>
      </div>
      <div
        class="state"
        [class.show]="!tableLoading && !hasError && !filteredRows.length"
      >
        <div class="ico-big"><i class="fa fa-inbox"></i></div>
        <h4>{{ emptyTitle }}</h4>
        <span class="muted">{{
          hasActiveFilters
            ? "فیلترها را تغییر دهید و دوباره جستجو کنید."
            : "هنوز اطلاعاتی ثبت نشده است."
        }}</span>
        <div class="empty-actions" *ngIf="hasActiveFilters">
          <button
            class="btn btn-primary"
            type="button"
            [disabled]="loading"
            (click)="clearSearch()"
          >
            <i class="fa fa-undo"></i> حذف فیلترها
          </button>
        </div>
      </div>
      <div class="state error" [class.show]="!tableLoading && hasError">
        <div class="ico-big"><i class="fa fa-exclamation-triangle"></i></div>
        <h4>دریافت اطلاعات با خطا مواجه شد</h4>
        <span class="muted">{{ errorMessage }}</span>
        <button
          class="btn btn-primary retry"
          type="button"
          [disabled]="loading"
          (click)="getAllSupport()"
        >
          <i class="fa fa-refresh"></i> تلاش مجدد
        </button>
      </div>
      <div
        class="table-scroll"
        *ngIf="!hasError && filteredRows.length"
        [hidden]="tableLoading"
        (scroll)="pageTooltip.hide()"
      >
        <ng-container
          [ngTemplateOutlet]="recordsTable"
          [ngTemplateOutletContext]="{
            data: pagedRows,
            offset: (currentPage - 1) * pageSize,
            printing: false
          }"
        ></ng-container>
      </div>
    </div>
    <app-table-pagination
      [page]="currentPage"
      [pageSize]="pageSize"
      [totalItems]="filteredRows.length"
      [pageSizeOptions]="pageSizeOptions"
      (pageChange)="onPageChange($event)"
      (pageSizeChange)="onPageSizeChange($event)"
    ></app-table-pagination>
  </section>
  <div
    class="print-only"
    [id]="printId"
    *ngIf="!tableLoading && !hasError && filteredRows.length"
  >
    <div class="table-page" dir="rtl">
      <h1 class="title">{{ tableTitle }}</h1>
      <ng-container
        [ngTemplateOutlet]="recordsTable"
        [ngTemplateOutletContext]="{
          data: filteredRows,
          offset: 0,
          printing: true
        }"
      ></ng-container>
    </div>
  </div>
  <ng-template
    #recordsTable
    let-data="data"
    let-offset="offset"
    let-printing="printing"
  >
    <table>
      <thead>
        <tr>
          <th *ngIf="!printing" class="col-ops sticky-first">عملیات</th>
          <th class="col-num">#</th>
          <th>شماره تیکت</th>
          <th>تاریخ</th>
          <th>زمان</th>
          <th>وضعیت تیکت</th>
          <th>موضوع تیکت</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of data; let i = index">
          <td *ngIf="!printing" class="col-ops sticky-first">
            <div class="row-ops">
              <button
                class="ico"
                type="button"
                [disabled]="loading"
                aria-label="مشاهده تیکت و اقدامات"
                data-tip="مشاهده تیکت و اقدامات"
                (mouseenter)="pageTooltip.show($event, 'مشاهده تیکت و اقدامات')"
                (mouseleave)="pageTooltip.hide()"
                (focus)="pageTooltip.show($event, 'مشاهده تیکت و اقدامات')"
                (blur)="pageTooltip.hide()"
                (click)="pageTooltip.hide(); onRecordAction('details', row)"
              >
                <i class="fa fa-eye"></i>
              </button>
            </div>
          </td>
          <td class="col-num">{{ offset + i + 1 | faNum }}</td>
          <td>{{ row.iTiket | faNum }}</td>
          <td>{{ row.strSaveDate | faNum }}</td>
          <td>{{ row.strSaveTime | faNum }}</td>
          <td>
            <span
              class="tag"
              [class.ok]="row.tiTiketStatus == 3 || row.tiTiketStatus == 6"
              [class.bad]="row.tiTiketStatus == 5"
              [class.warn]="
                row.tiTiketStatus != 3 &&
                row.tiTiketStatus != 6 &&
                row.tiTiketStatus != 5
              "
              >{{ row.strTiketStatus_strComment | faNum }}</span
            >
          </td>
          <td>{{ row.strTiketSubject_strComment | faNum }}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td *ngIf="!printing" class="sticky-first"></td>
          <td class="label" colspan="6">
            تعداد کل: {{ filteredRows.length | number | faNum }}
          </td>
        </tr>
      </tfoot>
    </table>
  </ng-template>
  <div class="modal fade rtl" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-describedby="ticketCreateHint" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header align-items-start">
          <div>
            <h2 class="modal-title" id="exampleModalLabel">ثبت تیکت</h2>
            <p class="muted mb-0 mt-2" id="ticketCreateHint">موضوع درخواست را انتخاب کنید و جزئیات آن را بنویسید.</p>
          </div>
          <button type="button" class="btn-close p-3" data-bs-dismiss="modal" aria-label="بستن"></button>
        </div>
        <div class="modal-body" [attr.aria-busy]="loading">
          <fieldset class="row g-3 border-0 p-0 m-0" [formGroup]="sabtModel" [disabled]="loading">
            <label class="field col-12" for="ticketSubject">
              <span class="field-label">موضوع درخواست <span class="text-danger">*</span></span>
              <select class="control" id="ticketSubject" formControlName="tiTiketSubject">
                <option value="">انتخاب موضوع</option>
                <option *ngFor="let item of ServiceTxt" [value]="item.tiTiketSubject">{{ item.strComment }}</option>
              </select>
            </label>
            <label class="field col-12" for="ticketDescription">
              <span class="field-label">توضیحات درخواست <span class="text-danger">*</span></span>
              <textarea class="control" id="ticketDescription" formControlName="strDetail" rows="5"
                aria-describedby="ticketDescriptionHint" placeholder="مشکل یا درخواست خود را شرح دهید"></textarea>
              <small class="muted" id="ticketDescriptionHint">جزئیاتی بنویسید که به بررسی سریع‌تر درخواست کمک می‌کند.</small>
            </label>
          </fieldset>
          <p *ngIf="loading" class="muted mt-3 mb-0" role="status" aria-live="polite">در حال پردازش درخواست…</p>
        </div>
        <div class="modal-footer gap-2">
          <button type="button" class="btn btn-ghost" data-bs-dismiss="modal">بستن</button>
          <button [disabled]="loading" type="button" class="btn btn-primary" (click)="sabt()">ارسال درخواست</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade rtl" id="exampleModal2" tabindex="-1" aria-labelledby="exampleModalLabel2" aria-describedby="ticketActionsHint" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header align-items-start">
          <div>
            <h2 class="modal-title" id="exampleModalLabel2">اقدامات تیکت</h2>
            <p class="muted mb-0 mt-2" id="ticketActionsHint">جزئیات درخواست و تاریخچهٔ پیگیری‌ها</p>
          </div>
          <button type="button" class="btn-close p-3" data-bs-dismiss="modal" aria-label="بستن"></button>
        </div>
        <div class="modal-body" [attr.aria-busy]="loading">
          <ng-container *ngIf="singelSupport as ticket">
            <dl class="row g-3 bg-light border rounded-3 p-3 m-0 mb-4">
              <div class="col-12 col-sm-6">
                <dt class="field-label mb-1">شماره تیکت</dt>
                <dd class="mb-0 fw-bold">{{ ticket.iTiket | faNum }}</dd>
              </div>
              <div class="col-12 col-sm-6">
                <dt class="field-label mb-1">وضعیت</dt>
                <dd class="mb-0"><span class="tag" [class.ok]="ticket.tiTiketStatus == 3 || ticket.tiTiketStatus == 6"
                  [class.bad]="ticket.tiTiketStatus == 5" [class.warn]="ticket.tiTiketStatus != 3 && ticket.tiTiketStatus != 6 && ticket.tiTiketStatus != 5">{{ ticket.strTiketStatus_strComment }}</span></dd>
              </div>
              <div class="col-12 col-sm-6">
                <dt class="field-label mb-1">موضوع</dt>
                <dd class="mb-0 text-break">{{ ticket.strTiketSubject_strComment }}</dd>
              </div>
              <div class="col-12 col-sm-6">
                <dt class="field-label mb-1">زمان ثبت</dt>
                <dd class="mb-0">{{ ticket.strSaveDate | faNum }} — {{ ticket.strSaveTime | faNum }}</dd>
              </div>
              <div class="col-12 border-top pt-3">
                <dt class="field-label mb-1">توضیحات درخواست</dt>
                <dd class="mb-0 text-break">{{ ticket.strDetail || 'توضیحی ثبت نشده است.' }}</dd>
              </div>
            </dl>
            <fieldset class="border-0 p-0 m-0 mb-4" [formGroup]="editModel" [disabled]="loading"
              *ngIf="ticket.tiTiketStatus != 5 && ticket.tiTiketStatus != 6">
              <label class="field" for="ticketActionType">
                <span class="field-label">نوع اقدام</span>
                <select class="control" id="ticketActionType" formControlName="tiTiketSubject">
                  <option *ngFor="let item of tiketStatus" [value]="item.tiTiketStatus">{{ item.strComment }}</option>
                </select>
              </label>
            </fieldset>
          </ng-container>
          <h3 class="h6 mb-3">تاریخچهٔ اقدامات</h3>
          <div *ngIf="loading" class="d-flex align-items-center justify-content-center gap-2 p-3" role="status" aria-live="polite">
            <div class="spinner" aria-hidden="true"></div><span>در حال دریافت اقدامات…</span>
          </div>
          <div class="table-scroll w-100 border rounded-3" role="region" aria-label="تاریخچهٔ اقدامات تیکت" tabindex="0">
            <table>
              <caption class="visually-hidden">تاریخ، زمان و شرح اقدامات انجام‌شده برای تیکت</caption>
              <thead><tr><th scope="col" class="col-num">#</th><th scope="col">تاریخ</th><th scope="col">زمان</th><th scope="col">شرح اقدام</th></tr></thead>
              <tbody>
                <tr *ngFor="let item of Actions; let i = index">
                  <td class="col-num">{{ i + 1 | faNum }}</td>
                  <td>{{ item.strDate | faNum }}</td>
                  <td>{{ item.strTime | faNum }}</td>
                  <td class="text-wrap text-break">{{ item.strActionDetail | faNum }}</td>
                </tr>
                <tr *ngIf="!loading && !Actions?.length"><td colspan="4" class="text-center p-4"><span class="muted">هنوز اقدامی برای این تیکت ثبت نشده است.</span></td></tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer" *ngIf="singelSupport && singelSupport.tiTiketStatus != 5 && singelSupport.tiTiketStatus != 6 && singelSupport.tiTiketStatus != 2">
          <div class="w-100 d-flex justify-content-end">
            <button [disabled]="loading" type="button" class="btn btn-primary" (click)="edit()">ویرایش</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-table-tooltip #pageTooltip></app-table-tooltip>
</main>
